export var Language;
(function (Language) {
    Language["AFAR"] = "aa";
    Language["AFRIKAANS"] = "af";
    Language["AKAN"] = "ak";
    Language["ALBANIAN"] = "sq";
    Language["AMHARIC"] = "am";
    Language["ARABIC"] = "ar";
    Language["ARAGONESE"] = "an";
    Language["ARMENIAN"] = "hy";
    Language["ASSAMESE"] = "as";
    Language["AVARIC"] = "av";
    Language["AVESTAN"] = "ae";
    Language["AYMARA"] = "ay";
    Language["AZERBAIJANI"] = "az";
    Language["BAMBARA"] = "bm";
    Language["BASHKIR"] = "ba";
    Language["BASQUE"] = "eu";
    Language["BELARUSIAN"] = "be";
    Language["BENGALI"] = "bn";
    Language["BISLAMA"] = "bi";
    Language["BOSNIAN"] = "bs";
    Language["BRETON"] = "br";
    Language["BULGARIAN"] = "bg";
    Language["BURMESE"] = "my";
    Language["CATALAN_VALENCIAN"] = "ca";
    Language["CHAMORRO"] = "ch";
    Language["CHECHEN"] = "ce";
    Language["CHICHEWA_CHEWA_NYANJA"] = "ny";
    Language["CHINESE"] = "zh";
    Language["CHUVASH"] = "cv";
    Language["CORNISH"] = "kw";
    Language["CORSICAN"] = "co";
    Language["CREE"] = "cr";
    Language["CROATIAN"] = "hr";
    Language["CZECH"] = "cs";
    Language["DANISH"] = "da";
    Language["DIVEHI_DHIVEHI_MALDIVIAN"] = "dv";
    Language["DUTCH_FLEMISH"] = "nl";
    Language["DZONGKHA"] = "dz";
    Language["ENGLISH"] = "en";
    Language["ESPERANTO"] = "eo";
    Language["ESTONIAN"] = "et";
    Language["EWE"] = "ee";
    Language["FAROESE"] = "fo";
    Language["FIJIAN"] = "fj";
    Language["FINNISH"] = "fi";
    Language["FRENCH"] = "fr";
    Language["FULAH"] = "ff";
    Language["GALICIAN"] = "gl";
    Language["GEORGIAN"] = "ka";
    Language["GERMAN"] = "de";
    Language["GREEK_MODERN"] = "el";
    Language["GUARANI"] = "gn";
    Language["GUJARATI"] = "gu";
    Language["HAITIAN"] = "ht";
    Language["HAUSA"] = "ha";
    Language["HEBREW"] = "he";
    Language["HERERO"] = "hz";
    Language["HINDI"] = "hi";
    Language["HIRI_MOTU"] = "ho";
    Language["HUNGARIAN"] = "hu";
    Language["INTERLINGUA"] = "ia";
    Language["INDONESIAN"] = "id";
    Language["INTERLINGUE"] = "ie";
    Language["IRISH"] = "ga";
    Language["IGBO"] = "ig";
    Language["INUPIAQ"] = "ik";
    Language["IDO"] = "io";
    Language["ICELANDIC"] = "is";
    Language["ITALIAN"] = "it";
    Language["INUKTITUT"] = "iu";
    Language["JAPANESE"] = "ja";
    Language["JAVANESE"] = "jv";
    Language["KALAALLISUT_GREENLANDIC"] = "kl";
    Language["KANNADA"] = "kn";
    Language["KANURI"] = "kr";
    Language["KASHMIRI"] = "ks";
    Language["KAZAKH"] = "kk";
    Language["CENTRAL_KHMER"] = "km";
    Language["KIKUYU_GIKUYU"] = "ki";
    Language["KINYARWANDA"] = "rw";
    Language["KIRGHIZ_KYRGYZ"] = "ky";
    Language["KOMI"] = "kv";
    Language["KONGO"] = "kg";
    Language["KOREAN"] = "ko";
    Language["KURDISH"] = "ku";
    Language["KUANYAMA_KWANYAMA"] = "kj";
    Language["LATIN"] = "la";
    Language["LUXEMBOURGISH_LETZEBURGESCH"] = "lb";
    Language["GANDA"] = "lg";
    Language["LIMBURGAN_LIMBURGER_LIMBURGISH"] = "li";
    Language["LINGALA"] = "ln";
    Language["LAO"] = "lo";
    Language["LITHUANIAN"] = "lt";
    Language["LUBA_KATANGA"] = "lu";
    Language["LATVIAN"] = "lv";
    Language["MANX"] = "gv";
    Language["MACEDONIAN"] = "mk";
    Language["MALAGASY"] = "mg";
    Language["MALAY"] = "ms";
    Language["MALAYALAM"] = "ml";
    Language["MALTESE"] = "mt";
    Language["MAORI"] = "mi";
    Language["MARATHI"] = "mr";
    Language["MARSHALLESE"] = "mh";
    Language["MONGOLIAN"] = "mn";
    Language["NAURU"] = "na";
    Language["NAVAJO_NAVAHO"] = "nv";
    Language["NORTH_NDEBELE"] = "nd";
    Language["NEPALI"] = "ne";
    Language["NDONGA"] = "ng";
    Language["NORWEGIAN_BOKMAL"] = "nb";
    Language["NORWEGIAN_NYNORSK"] = "nn";
    Language["NORWEGIAN"] = "no";
    Language["SICHUAN_YI_NUOSU"] = "ii";
    Language["SOUTH_NDEBELE"] = "nr";
    Language["OCCITAN"] = "oc";
    Language["OJIBWA"] = "oj";
    Language["OLD_SLAVONIC"] = "cu";
    Language["OROMO"] = "om";
    Language["ORIYA"] = "or";
    Language["OSSETIAN_OSSETIC"] = "os";
    Language["PUNJABI_PANJABI"] = "pa";
    Language["PALI"] = "pi";
    Language["PERSIAN"] = "fa";
    Language["POLISH"] = "pl";
    Language["PASHTO_PUSHTO"] = "ps";
    Language["PORTUGUESE"] = "pt";
    Language["QUECHUA"] = "qu";
    Language["ROMANSH"] = "rm";
    Language["RUNDI"] = "rn";
    Language["ROMANIAN_MOLDAVIAN"] = "ro";
    Language["RUSSIAN"] = "ru";
    Language["SANSKRIT"] = "sa";
    Language["SARDINIAN"] = "sc";
    Language["SINDHI"] = "sd";
    Language["NORTHERN_SAMI"] = "se";
    Language["SAMOAN"] = "sm";
    Language["SANGO"] = "sg";
    Language["SERBIAN"] = "sr";
    Language["GAELIC"] = "gd";
    Language["SHONA"] = "sn";
    Language["SINHALA_SINHALESE"] = "si";
    Language["SLOVAK"] = "sk";
    Language["SLOVENIAN"] = "sl";
    Language["SOMALI"] = "so";
    Language["SOUTHERN_SOTHO"] = "st";
    Language["SPANISH_CASTILIAN"] = "es";
    Language["SUNDANESE"] = "su";
    Language["SWAHILI"] = "sw";
    Language["SWATI"] = "ss";
    Language["SWEDISH"] = "sv";
    Language["TAMIL"] = "ta";
    Language["TELUGU"] = "te";
    Language["TAJIK"] = "tg";
    Language["THAI"] = "th";
    Language["TIGRINYA"] = "ti";
    Language["TIBETAN"] = "bo";
    Language["TURKMEN"] = "tk";
    Language["TAGALOG"] = "tl";
    Language["TSWANA"] = "tn";
    Language["TONGA"] = "to";
    Language["TURKISH"] = "tr";
    Language["TSONGA"] = "ts";
    Language["TATAR"] = "tt";
    Language["TWI"] = "tw";
    Language["TAHITIAN"] = "ty";
    Language["UIGHUR"] = "ug";
    Language["UKRAINIAN"] = "uk";
    Language["URDU"] = "ur";
    Language["UZBEK"] = "uz";
    Language["VENDA"] = "ve";
    Language["VIETNAMESE"] = "vi";
    Language["VOLAPUK"] = "vo";
    Language["WALLOON"] = "wa";
    Language["WELSH"] = "cy";
    Language["WOLOF"] = "wo";
    Language["WESTERN_FRISIAN"] = "fy";
    Language["XHOSA"] = "xh";
    Language["YIDDISH"] = "yi";
    Language["YORUBA"] = "yo";
    Language["ZHUANG_CHUANG"] = "za";
    Language["ZULU"] = "zu";
})(Language || (Language = {}));
